.productDetailTag {
  border-radius: var(--border-radius-sm);
}

.indicaTag {
  background-color: var(--bloom-colors-indica);
  color: var(--bloom-colors-indica-contrast);
}

.cbdTag {
  background-color: var(--bloom-colors-cbd);
  color: var(--bloom-colors-cbd-contrast);
}

.hybridTag {
  background-color: var(--bloom-colors-hybrid);
  color: var(--bloom-colors-hybrid-contrast);
}

.sativaTag {
  background-color: var(--bloom-colors-sativa);
  color: var(--bloom-colors-sativa-contrast);
}

.pdpCardBoxes {
  overflow-y: auto;
}
